import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconButton, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import OtpInput from 'react-otp-input';
import { useTheme } from '@emotion/react';
import { api } from 'src/Api';
import Iconify from 'src/components/Iconify';
import palette from 'src/theme/palette';

// ----------------------------------------------------------------------//

export default function OtpForm() {
  const location = useLocation();

  const { user, token, code, email, message, from } = location.state || {};
  console.log('token=====', token, code, email);

  const theme = useTheme();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [alert, setalert] = useState({ visible: false, message: '', color: 'success' });
  const [loading, setloading] = useState(false);
  // const { result } = location.state || {};
  const [codeotp, setCodeOtp] = useState(code);
  const [resendotp, setresendotp] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds == 0) {
        if (minutes == 0) {
          clearInterval(interval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [minutes, seconds]);

  const otpInputStyle = {
    width: '100%',
    height: '56px',
    textAlign: 'center',
    fontSize: '18px',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: '6px',
    border: `1px solid ${theme.palette.primary.main} !important`
  };

  const otpContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  };

  // const codeCheck = localStorage.getItem('code');

  function VerifyCode() {
    if (codeotp == otp) {
      console.log('otp match');
      var formdata = new FormData();
      formdata.append('email', email);
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };
      setloading(true);

      fetch(api.verify_user, requestOptions)
        .then((response) =>
          response.text().then((result) => ({ status: response.status, body: result }))
        )
        .then(({ status, body }) => {
          const result = JSON.parse(body);
          if (status === 200 || status === 201) {
            if (from === 'forgetPassword') {
              navigate('/changePassword', { replace: true, state: { email: email } });
            } else {
              setalert({ visible: true, message: result.message });
              localStorage.setItem('token', token);
              localStorage.setItem('user', JSON.stringify(user));
              setTimeout(() => {
                navigate('/login', { replace: true });
              }, 2000);
            }
            setloading(false);
          } else {
            setloading(false);
            setalert({ visible: true, message: result.error, color: 'error' });
          }
        })
        .catch((error) => {
          setloading(false);
          setalert({ visible: true, message: 'An error occurred.', color: 'error' });
        });
    } else {
      setalert({ visible: true, message: 'OTP does not match', color: 'error' });
      setloading(false);
    }
  }

  const ResendOTP = () => {
    setresendotp(true);
    var formdata = new FormData();
    console.log('otp resend ', email);
    formdata.append('email', email);
    var requestOptions = {
      method: 'POST',
      body: formdata
    };
    fetch(api.send_opt, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setCodeOtp(result?.code);
          setloading(false);
          handleResend();
        } else {
          setalert({ visible: true, message: result.error, color: 'error' });
        }
      })
      .catch((error) => {
        setalert({ visible: true, message: 'An error occurred.', color: 'error' });
      })
      .finally(() => {
        setresendotp(false);
      });
  };

  // function VerifyCode() {
  //   var myHeaders = new Headers();
  //   myHeaders.append('Content-Type', 'application/json');

  //   var requestOptions = {
  //     method: 'POST',
  //     headers: myHeaders,
  //     body: JSON.stringify({
  //       email: localStorage.getItem('email'),
  //       otp: otp
  //     }),
  //     redirect: 'follow'
  //   };

  //   setloading(true);

  //   // const { from, result } = location.state || {}

  //   fetch(api.otp_verify, requestOptions)
  //     .then((response) => {
  //       if (response.status === 200 || response.status === 201) {
  //         if (from === "forgetPassword") {
  //           navigate('/changePassword', { replace: true, state: { email: user?.email } });
  //         } else {
  //           localStorage.setItem('token', token);
  //           localStorage.setItem('user', JSON.stringify(user));
  //         }
  //         return response.json();
  //       } else {
  //         return response.json().then((error) => {
  //           setalert({ visible: true, message: error.error, color: 'error' });
  //         });
  //       }
  //     })
  //     // .then((result) => {
  //     //   if (result.status === 200 || result.status === 201) {
  //     //     setalert({ visible: true, message: result.message, color: 'success' });
  //     //   }
  //     // })
  //     // .catch((error) => {
  //     //   if (response.status === 400 || response.status === 401) {
  //     //     console.log('error', error);
  //     //     setalert({ visible: true, message: error?.message, color: 'error' });
  //     //   }
  //     // })
  //     .finally(() => {
  //       setloading(false);
  //     });
  // }

  const handlecode = () => {
    setloading(true);

    if (seconds == 0) {
      // showToastError('OTP has been expired. Please request a new one.');
      setalert({
        visible: true,
        message: 'OTP has been expired. Please request a new one',
        color: 'error'
      });
      setloading(false);
    } else {
      VerifyCode();
    }
  };

  const handleResend = () => {
    setMinutes(0);
    setSeconds(60);
  };

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : `${time}`;
  };

  return (
    <Stack spacing={2}>
      {alert.visible && (
        <Alert
          onClose={() => {
            setalert({ visible: false, message: '', color: 'success' });
          }}
          severity={alert?.color}
        >
          {alert.message}
        </Alert>
      )}
      <div style={otpContainerStyle}>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={5}
          renderSeparator={<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}
          renderInput={(props) => <input {...props} style={otpInputStyle} />}
        />
      </div>
      <LoadingButton
        onClick={handlecode}
        fullWidth
        size="large"
        variant="contained"
        loading={loading}
      >
        Continue
      </LoadingButton>
      <LoadingButton
        disableElevation
        sx={{
          backgroundColor: seconds == 0 ? '#f90001' : '#ccc',
          boxShadow: seconds !== 0 && 'none',
          '&:hover': {
            boxShadow: 'none', // Ensure no shadow on hover as well
            // backgroundColor: seconds === 0 ? '#d00001' : '#ccc',
            backgroundColor: '#ccc',
            disableElevation: true
          }
        }}
        // style={{
        //   backgroundColor: seconds == 0 ? '#f90001' : '#ccc'
        // }}
        onClick={() => {
          if (seconds == 0) {
            ResendOTP();
          }
        }}
        fullWidth
        size="large"
        variant="contained"
        loading={resendotp}
      >
        {seconds > 0 ? `\t ${formatTime(minutes)}:${formatTime(seconds)}` : <>Resend OTP</>}
      </LoadingButton>

      <LoadingButton
        style={{ marginTop: 10 }}
        fullWidth
        size="large"
        type="submit"
        variant="outlined"
        onClick={() => {
          // navigate(-1);
          navigate('/login');
        }}
      >
        Back to Login
      </LoadingButton>
    </Stack>
  );
}
